// extracted by mini-css-extract-plugin
module.exports = {"questionBox":"FAQBox_questionBox__dRVr6"};